<template src='./gestionAdministrativo.html'></template>
<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import formularioOverlay from "../../formularioOverlay/formularioOverlay";
import {
  consultarOrdenes,
  consultarOrdenesEstado,
  descargarOrdenes,
  consultarOrdenesEstadoPorServicio,
  cambiarEstadoGrupoOrdenes,
} from "../../../apiService/request/gestionSeguimientos";
import {
  consultarOrden,
  crearOrdenDesdeFormulario,
  actualizarEstadoOrdenesDesdeExcel,
} from "../../../apiService/request/CrudOrdenes";
import metodos_comunes from "../../../js/metodos_comunes";
import Icono from "../../Icono/Icono";
import { serverBus } from "../../../main";
import {
  consultarTipoEncuentroSeguimiento,
  crearCuestionario,
  consultarEstructuraCuestionarioPorId,
} from "../../../apiService/request/CrudSeguimiento";
import mixinGraficas from "../../../js/mixins/mixinGraficas";
import mixinScroll from "../../../js/mixins/mixinScroll";
import FiltrosGestion from "../FiltrosGestion/FiltrosGestion";
import OverlaySubirArchivo from "../../OverlaySubirArchivo/OverlaySubirArchivo";
export default {
  data() {
    return {
      fileSelected: null,
      fechaActual: "",
      date: Date.now(),
      fechaSeleccionada: "",
      miliSegundos: Number,
      diaSeleccionado: [],
      search: "",
      indexPadre: "",
      iPadre: "",
      indexHijo: "",
      iHijo: "",
      iconoCargar:
        "M35.9,18.2C35,11.3,29,6,22,6c-5.6,0-10.5,3.3-12.8,8.3C3.8,15.6,0,20.4,0,26c0,6.6,5.4,12,12,12h22c5.5,0,10-4.5,10-10C44,23.1,40.6,19.1,35.9,18.2z M34,36H12C6.5,36,2,31.5,2,26c0-4.8,3.4-8.9,8.1-9.8l0.5-0.1l0.2-0.5C12.7,11,17.1,8,22,8c6.3,0,11.5,4.9,12,11.1L34,20l0.8,0.1c4.1,0.4,7.2,3.8,7.2,8C42,32.4,38.4,36,34,36z M28.7,21.3c0.4,0.4,0.4,1,0,1.4C28.5,22.9,28.3,23,28,23s-0.5-0.1-0.7-0.3L23,18.4V31c0,0.6-0.4,1-1,1s-1-0.4-1-1V18.4l-4.3,4.3C16.5,22.9,16.3,23,16,23s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l6-6c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.1,0.5-0.1,0.8,0c0.1,0.1,0.2,0.1,0.3,0.2L28.7,21.3zM0,0h44 M44,44H0",
      opciones: [
        {
          chart: {
            stacked: true,
            toolbar: {
              show: false,
            },
            events: {
              dataPointSelection: async (event, chartContext, config) => {
                await this.clickParent(config.dataPointIndex);
              },
              click: async (event, chartContext, config) => {
                if (
                  event &&
                  event.target &&
                  (event.target.className === "apexcharts-legend-text" ||
                    event.target.className === "apexcharts-legend-series" ||
                    event.target.className === "apexcharts-legend-marker")
                ) {
                  await this.clickParent(
                    Number(event.target.getAttribute("rel")) - 1
                  );
                }
              },
            },
          },
          legend: {
            // show: true,
            position: "bottom",
            horizontalAlign: "left",
            offsetX: 40,
            height: 100,
          },
          states: {
            active: {
              allowMultipleDataPointsSelection: false,
              filter: {
                type: "darken",
                value: 0.4,
              },
            },
          },
          // colors: ["#3A5FBA", "#3D88C4", "#3F9AAE"],
          colors: [
            "#579FF2",
            "#946EEB",
            "#90A4AE",
            "#F0706C",
            "#B7C53B",
            "#F38D89",
            "#D493B0",
            "#45B8DD",
            "#BA567C",
            "#3ABA8B",
            "#55669F",
            "#EFE18B",
            "#ED8432",
            "#F0AE7B",
          ],
          dataLabels: {
            // enabled: false
            textAnchor: "center",
            style: {
              colors: ["#fff"],
              fontSize: 15,
            },
            offsetX: 0,
          },
          grid: {
            row: {
              // colors: ["#f9f9f9", "#fff"]
              colors: ["#F4F5F8"],
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: ["#646a6f"],
                fontSize: "16px",
                fontFamily: "Nunito, sans-serif",
              },
              min: 20,
            },
          },
          fill: {
            // colors: ["#3D88C4"],
            type: "gradient",
            gradient: {
              shade: "light",
            },
          },
          plotOptions: {
            bar: {
              // horizontal: true
              distributed: true,
              horizontal: true,
            },
            colors: ["#3D88C4"],
          },
          yaxis: {
            labels: {
              show: false,
              style: {
                fontSize: 20 /**El texto de la izquierda de la grafica */,
                fontSize: "16px",
                fontFamily: "Nunito, sans-serif",
              },
            },
          },
        },
        {
          chart: {
            type: "bar",
            height: 350,
            stacked: true,
            toolbar: {
              show: false,
            },
            events: {
              dataPointSelection: (event, chartContext, config) => {
                this.showTable(config.dataPointIndex);
              },
              click: (event, chartContext, config) => {
                if (
                  event &&
                  event.target &&
                  (event.target.className === "apexcharts-legend-text" ||
                    event.target.className === "apexcharts-legend-series" ||
                    event.target.className === "apexcharts-legend-marker")
                ) {
                  this.showTable(Number(event.target.getAttribute("rel")) - 1);
                }
              },
            },
          },
          legend: {
            // show: true,
            position: "bottom",
            horizontalAlign: "left",
            offsetX: 20,
            height: 100,
          },
          states: {
            active: {
              allowMultipleDataPointsSelection: false,
              filter: {
                type: "darken",
                value: 0.3,
              },
            },
          },
          // colors: ["#3A5FBA", "#3D88C4", "#3F9AAE"],
          colors: [
            "#579FF2",
            "#946EEB",
            "#90A4AE",
            "#F0706C",
            "#B7C53B",
            "#F38D89",
            "#D493B0",
            "#45B8DD",
            "#BA567C",
            "#3ABA8B",
            "#55669F",
            "#EFE18B",
            "#ED8432",
            "#F0AE7B",
          ],
          dataLabels: {
            // enabled: false
            textAnchor: "center",
            style: {
              colors: ["#fff"],
              fontSize: 15,
            },
            offsetX: 0,
          },
          grid: {
            row: {
              // colors: ["#f9f9f9", "#fff"]
              colors: ["#F4F5F8"],
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: ["#646a6f"],
                fontSize: "16px",
                fontFamily: "Nunito, sans-serif",
              },
              min: 20,
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "light",
            },
          },
          plotOptions: {
            bar: {
              distributed: true,
              horizontal: true,
            },
            colors: ["#3D88C4"],
          },
          yaxis: {
            labels: {
              show: false,
              style: {
                fontSize: 20 /**El texto de la izquierda de la grafica */,
                fontSize: "16px",
                fontFamily: "Nunito, sans-serif",
              },
            },
          },
        },
      ],
      series: [
        {
          data: [],
        },
      ],
      seguimiento: [
        {
          nombre_lista: "Tipo gestión",
          key_lista: "tipo_gestion",
          opciones_lista: [
            {
              nombre: "Gestión llamadas",
              key: "llamada",
              valor: "Gestión llamadas",
            },
            {
              nombre: "Gestión seguimientos",
              key: "seguimiento",
              valor: "Gestión seguimientos",
            },
            {
              nombre: "Gestión ayudas diagnósticas",
              key: "ayuda_diagnostica",
              valor: "Gestión ayudas diagnósticas",
            },
          ],
        },
      ],
      loader: null,
      loading3: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      banderaGrafica: false,
      banderaTabla: false,
      headers: [],
      desserts: [],
      sort_by: [],
      sort_desc: [],
      respuestaPadre: [],
      respuestaHijo: [],
      overlay: false,
      docId: "",
      item: "",
      arrayGraficas: [],
      graficaKey: 0,
      indexGraficaSeleccionada: 0,
      verComponente: "",
      arrayGraficaPadre: [],
      parametrosPadre: [],
      parametrosHijo: [],
      tituloPadre: "",
      tituloHijo: "",
      verEncuentro:
        "M31.3,8.6h-4V8.1c0-0.6-0.4-1-1-1H25C24.6,5.9,23.4,5,22,5s-2.6,0.9-3,2.1h-1.3c-0.6,0-1,0.4-1,1v0.4h-4c-1.3,0-2.4,1.1-2.4,2.4v23.6c0,1.3,1.1,2.4,2.4,2.4h18.6c1.3,0,2.4-1.1,2.4-2.4V11C33.7,9.7,32.6,8.6,31.3,8.6z M28.9,13.4v18.7H15.1V13.4H28.9z M18.7,9.1h1.1c0.6,0,1-0.4,1-1C20.9,7.5,21.4,7,22,7s1.1,0.5,1.1,1.1c0,0.6,0.4,1,1,1h1.1v2.3h-6.6V9.1zM31.7,34.6c0,0.2-0.2,0.4-0.4,0.4H12.7c-0.2,0-0.4-0.2-0.4-0.4V11c0-0.2,0.2-0.4,0.4-0.4h4v0.9h-2.6c-0.6,0-1,0.4-1,1v20.7c0,0.6,0.4,1,1,1h15.7c0.6,0,1-0.4,1-1V12.4c0-0.6-0.4-1-1-1h-2.6v-0.9h4c0.2,0,0.4,0.2,0.4,0.4V34.6z M17,25.1h2.3v2.3c0,0.6,0.4,1,1,1h3.3c0.6,0,1-0.4,1-1v-2.3H27c0.6,0,1-0.4,1-1v-3.3c0-0.6-0.4-1-1-1h-2.3v-2.3c0-0.6-0.4-1-1-1h-3.3c-0.6,0-1,0.4-1,1v2.3H17c-0.6,0-1,0.4-1,1v3.3C16,24.6,16.4,25.1,17,25.1z M18,21.8h2.3c0.6,0,1-0.4,1-1v-2.3h1.3v2.3c0,0.6,0.4,1,1,1H26v1.3h-2.3c-0.6,0-1,0.4-1,1v2.3h-1.3v-2.3c0-0.6-0.4-1-1-1H18V21.8z M22,0C9.9,0,0,9.9,0,22s9.9,22,22,22s22-9.9,22-22S34.1,0,22,0z M22,42C11,42,2,33,2,22S11,2,22,2s20,9,20,20S33,42,22,42z",
      modificar:
        "M29.8,30.9c-2.2,1.9-4.9,2.9-7.8,2.9c-6.2,0-11.3-4.8-11.8-10.9h1.1c0.3,0,0.6-0.2,0.8-0.4c0.2-0.3,0.2-0.6,0.1-0.9l-2.1-5 C9.9,16.2,9.5,16,9.1,16s-0.8,0.2-0.9,0.6l-2.1,5c-0.1,0.3-0.1,0.7,0.1,0.9C6.4,22.8,6.7,23,7,23h1.2c0.5,7.2,6.5,12.9,13.8,12.9 c3.4,0,6.6-1.2,9.1-3.4c0.4-0.4,0.5-1,0.1-1.4C30.9,30.6,30.2,30.6,29.8,30.9z M9.1,19.5L9.8,21H8.5L9.1,19.5z M22,8.1c-3.4,0-6.6,1.2-9.1,3.4c-0.4,0.4-0.5,1-0.1,1.4c0.4,0.4,1,0.5,1.4,0.1c2.2-1.9,4.9-2.9,7.8-2.9c6.2,0,11.3,4.8,11.8,10.9h-1.1c-0.3,0-0.6,0.2-0.8,0.4c-0.2,0.3-0.2,0.6-0.1,0.9l2.1,5c0.2,0.4,0.5,0.6,0.9,0.6s0.8-0.2,0.9-0.6l2.1-5c0.1-0.3,0.1-0.7-0.1-0.9 C37.6,21.2,37.3,21,37,21h-1.2C35.3,13.8,29.3,8.1,22,8.1z M34.9,24.5L34.2,23h1.3L34.9,24.5z M22,0C9.9,0,0,9.9,0,22s9.9,22,22,22s22-9.9,22-22S34.1,0,22,0z M22,42C11,42,2,33,2,22S11,2,22,2s20,9,20,20S33,42,22,42z",
      agregar:
        "M22,35c-1.7,0-3-1.3-3-3v-7h-7c-1.7,0-3-1.3-3-3s1.3-3,3-3h7v-7c0-1.7,1.3-3,3-3s3,1.3,3,3v7h7c1.7,0,3,1.3,3,3s-1.3,3-3,3 h-7v7C25,33.7,23.7,35,22,35z M12,21c-0.6,0-1,0.4-1,1s0.4,1,1,1h8c0.6,0,1,0.4,1,1v8c0,0.6,0.4,1,1,1s1-0.4,1-1v-8c0-0.6,0.4-1,1-1 h8c0.6,0,1-0.4,1-1s-0.4-1-1-1h-8c-0.6,0-1-0.4-1-1v-8c0-0.6-0.4-1-1-1s-1,0.4-1,1v8c0,0.6-0.4,1-1,1H12z M22,44C9.9,44,0,34.1,0,22 S9.9,0,22,0s22,9.9,22,22S34.1,44,22,44z M22,2C11,2,2,11,2,22s9,20,20,20s20-9,20-20S33,2,22,2z",
      usuarios: [],
      iconoBoton:
        "M43,37.3H1c-0.6,0-1,0.4-1,1V43c0,0.6,0.4,1,1,1h42c0.6,0,1-0.4,1-1v-4.7C44,37.8,43.6,37.3,43,37.3z M42,42H2v-2.7h40V42zM10.8,23.9c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l8.8,8.8V1c0-0.6,0.4-1,1-1s1,0.4,1,1v30.3l8.8-8.8c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L22.7,34.4c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.3,0.1-0.4,0.1s-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2L10.8,23.9z",
      iconoBotonSubir:
        "M35.9,18.2C35,11.3,29,6,22,6c-5.6,0-10.5,3.3-12.8,8.3C3.8,15.6,0,20.4,0,26c0,6.6,5.4,12,12,12h22c5.5,0,10-4.5,10-10C44,23.1,40.6,19.1,35.9,18.2z M34,36H12C6.5,36,2,31.5,2,26c0-4.8,3.4-8.9,8.1-9.8l0.5-0.1l0.2-0.5C12.7,11,17.1,8,22,8c6.3,0,11.5,4.9,12,11.1L34,20l0.8,0.1c4.1,0.4,7.2,3.8,7.2,8C42,32.4,38.4,36,34,36z M28.7,21.3c0.4,0.4,0.4,1,0,1.4C28.5,22.9,28.3,23,28,23s-0.5-0.1-0.7-0.3L23,18.4V31c0,0.6-0.4,1-1,1s-1-0.4-1-1V18.4l-4.3,4.3C16.5,22.9,16.3,23,16,23s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l6-6c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.1,0.5-0.1,0.8,0c0.1,0.1,0.2,0.1,0.3,0.2L28.7,21.3zM0,0h44 M44,44H0",
      items: [5, 10, 30, 50],
      showDialog: false,
      paciente: {},
      cedulaPaciente: Number,
      idFormulario: "",
      id: "",
      banderaSubirArchivo: true,
      selected: [],
      contadorGruposActualizados: 0,
      interval: {},
      valorPorcentaje: 0,
      overlaySubirArchivo: false,
    };
  },
  mixins: [mixinGraficas, mixinScroll],
  components: {
    apexcharts: VueApexCharts,
    formularioOverlay,
    Icono,
    FiltrosGestion,
    OverlaySubirArchivo,
  },
  mounted() {
    // this.$store.dispatch("setCargando", true);
    // this.$emit('barra-progreso', true)
    // this.interval = setInterval(() => {
    //   if (this.valorPorcentaje === 100) {
    //     this.valorPorcentaje = 0
    //     this.$emit('valor-progreso', this.valorPorcentaje)
    //     return;
    //     }
    //     this.valorPorcentaje += 10
    //     this.$emit('valor-progreso', this.valorPorcentaje)
    //   }, 3000)
  },
  beforeUpdate() {},
  beforeDestroy() {
    this.$emit("barra-progreso", false);
    this.$store.dispatch("setCargando", false);
    clearInterval(this.interval);
  },
  props: ["valorSeleccionadoDialogo"],
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    },
    valorSeleccionadoDialogo: async function (valor) {
      if (valor === "Aceptar" && this.tituloPadre === "factura") {
        this.obtenerTodosDocId();
      } else if (valor === "Aceptar" && this.tituloPadre === "nueva") {
        try {
          this.$store.dispatch("setCargando", true);
          const respuesta = await actualizarEstadoOrdenesDesdeExcel(
            this.fileSelected,
            "autorizada"
          );
          if (
            respuesta.status === 200 &&
            respuesta.data &&
            respuesta.data.data
          ) {
            const dialogoModal = {
              status: 200,
              dialogo: false,
              data: {
                message: respuesta.data.message,
              },
            };
            this.$store.dispatch("cambiarEstadoModal", true);
            this.$store.dispatch("cambiarMensajeModal", dialogoModal);
          }
        } catch (err) {
          console.log(err);
          this.$store.dispatch("setCargando", false);
        } finally {
          this.$store.dispatch("setCargando", false);
          this.cerrarOverlay(false);
        }
      }
    },
  },
  methods: {
    forceRerender() {
      this.graficaKey += 1;
    },
    cerrarOverlaySinActualizar() {
      this.overlay = false;
    },
    async cerrarOverlay(valor) {
      this.paciente = {};
      // this.overlay = valor;
      await this.consultarDatosGrafica(
        this.datosConsultaPadre.tipo_gestion,
        this.datosConsultaPadre.fechaInicial,
        this.datosConsultaPadre.fechaFinal,
        this.datosConsultaPadre.estados
      );
      await this.clickParent(
        // this.parametrosPadre[0],
        // this.parametrosPadre[1],
        this.parametrosPadre[2]
      );
      await this.showTable(
        // this.parametrosHijo[0],
        // this.parametrosHijo[1],
        this.parametrosHijo[2]
      );
      if (!this.banderaSubirArchivo) {
        this.formularioActualizado();
      }
      this.overlay = valor;
    },
    async consultarDatosGrafica(
      tipo_gestion,
      fechaInicial,
      fechaFinal,
      estados
    ) {
      try {
        this.banderaGrafica = false;
        this.banderaTabla = false;
        this.$store.dispatch("setCargando", true);
        this.respuestaPadre = await consultarOrdenesEstado(
          tipo_gestion,
          fechaInicial,
          fechaFinal,
          estados
        );
        this.datosConsultaPadre = {
          tipo_gestion,
          fechaInicial,
          fechaFinal,
          estados,
        };
        this.respuestaPadre.data.data.headers.push({
          text: "Gestión",
          value: "gestion",
          sortable: false,
        });
        this.getGraphicData(this.respuestaPadre, 0);
      } finally {
        this.banderaGrafica = true;
        this.$store.dispatch("setCargando", false);
      }
    },
    async clickParent(indice) {
      this.parametrosPadre = [0, 0, indice];
      try {
        this.$store.dispatch("setCargando", true);
        this.banderaTabla = false;
        this.respuestaHijo = await consultarOrdenesEstadoPorServicio(
          this.datosConsultaPadre.tipo_gestion,
          this.datosConsultaPadre.fechaInicial,
          this.datosConsultaPadre.fechaFinal,
          this.respuestaPadre.data.data.ejeX[indice]
        );
        this.getGraphicData(this.respuestaHijo, 1);
      } finally {
        this.tituloPadre = this.respuestaPadre.data.data.ejeX[indice];
        this.tituloHijo = "";
        this.forceRerender();
        this.$store.dispatch("setCargando", false);
      }
      this.respuestaHijo.data.data.headers.push({
        text: "Gestión",
        value: "gestion",
        sortable: false,
      });
    },
    async showTable(indice) {
      try {
        this.$store.dispatch("setCedulaPaciente", null);
        this.headers = [];
        this.parametrosHijo = [0, 0, indice];
        this.usuarios =
          this.respuestaHijo &&
          this.respuestaHijo.data.data &&
          this.respuestaHijo.data.data.usuarios
            ? this.respuestaHijo.data.data.usuarios[indice]
            : null;
        this.banderaTabla = true;
        this.desserts = this.usuarios;
        this.headers = this.respuestaHijo.data.data.headers;
        this.sort_by = this.respuestaHijo.data.data.sort_by;
        this.tituloHijo = this.respuestaHijo.data.data.ejeX[indice];
      } finally {
        setTimeout(() => {
          this.autoScroll(
            "tablaPrestacionSeleccionada",
            "graficaGestionAdministrativo",
            0
          );
        }, 100);
      }
    },
    async download() {
      try {
        const headers = this.headers.slice(0, this.headers.length - 1);
        const respuesta = await descargarOrdenes({
          headers,
          data: this.usuarios,
        });
        if (respuesta && respuesta.data) {
          window.open(respuesta.data.data);
        }
      } finally {
        if (this.tituloPadre == "factura") {
          this.cambioEstadoOrdenes();
        }
      }
    },
    /**
     * Genera un dialogo subir un archivo de excel
     */
    async subirArchivoExcel(event) {
      if (event && event.target && event.target.files) {
        this.fileSelected = event.target.files[0];
        const dialogoModal = {
          dialogo: true,
          mensaje: `¿Está seguro de cambiar el estado de las ordenes del archivo ${this.fileSelected.name} al estado 'autorizada'?`,
          opciones: ["Aceptar", "Cancelar"],
          status: 200,
        };
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", dialogoModal);
      }
    },
    /**
     * Se usa para limpiar el elemento input (file) cada vez que se consulta.
     */
    async limpiarInput(event) {
      if (event.target && event.target.value) {
        event.target.value = null;
      }
    },
    // async successFunction(item) {
    //   if (item.origen == "seguimientos") {
    //     this.verComponente = "seguimientos";
    //   } else if (item.origen == "encuentros") {
    //     this.verComponente = "encuentros";
    //   }
    //   await this.consultarTipoEncuentroSeguimientoPaciente(item.origen,item.id)
    //   this.$store.dispatch("setId", item.id);
    //   this.$store.dispatch("setCedulaPaciente", item.documento);
    //   this.paciente = item;
    //   this.overlay = true;
    //   serverBus.$emit("verEncuentroGestion", this.overlay);
    // },
    // failedFunction(item) {
    //   this.$store.dispatch("setIdFormulario", item.docId);
    //   this.$store.dispatch("setCedulaPaciente", item.documento);
    //   this.paciente = item;
    //   this.getOrder(item.docId);
    // },
    // async crearOrden(item) {
    //   this.$store.dispatch("setCargando", true);
    //   const respuesta = await crearCuestionario('informacion_ordenes', item.documento, this.$store.state.provider_email, item.id, 'formularios');
    //   this.$store.dispatch('setCedulaPaciente',item.documento)
    //   this.cedulaPaciente=item.documento
    //   this.idFormulario=respuesta.data.data.docId
    //   this.id=item.id
    //   this.banderaSubirArchivo=false
    //   this.$store.dispatch('setIdFormulario',respuesta.data.data.docId)
    //   this.consultarEsquemaCuestionarioSeguimiento(respuesta.data.data.docId, 'formularios')
    // },
    // async consultarEsquemaCuestionarioSeguimiento(formulario_id, tipo){
    //   try{
    //     const respuesta = await consultarEstructuraCuestionarioPorId(formulario_id, tipo)
    //     this.preguntasEncuestas=respuesta.data.data.variables
    //     this.keyFormulario=respuesta.data.data.key
    //     this.$store.dispatch("setBanderaFormularioCreadoPanel", true);
    //     this.$store.dispatch('setVariablesFormularios',respuesta.data.data.variables)
    //     this.$store.dispatch('setNombreFormulario',respuesta.data.data.key)
    //     this.$store.dispatch("setColeccion", respuesta.data.data.coleccion);
    //     this.overlay = true;
    //     this.verComponente = "ordenes";
    //     this.$store.dispatch("setCargando", false);
    //     // this.consultarListaCuestionarioGeneral()
    //     // this.preguntasEncuestas=respuesta
    //   }
    //   catch (err){
    //   }
    // },
    // async getOrder(docId) {
    //   const response = await consultarOrden(docId);
    //   this.$store.dispatch(
    //     "setVariablesFormularios",
    //     response.data.data.variables
    //   );
    //   this.$store.dispatch("setNombreFormulario", response.data.data.key);
    //   this.$store.dispatch("setColeccion", response.data.data.coleccion);
    //   this.overlay = true;
    //   this.verComponente = "ordenes";
    // }
    cambioEstadoOrdenes() {
      const dialogoModal = {
        dialogo: true,
        mensaje: "¿Está seguro de cambiar el estado de esta orden?",
        opciones: ["Aceptar", "Cancelar"],
        status: 200,
      };
      this.$store.dispatch("cambiarEstadoModal", true);
      this.$store.dispatch("cambiarMensajeModal", dialogoModal);
    },
    obtenerDocId() {
      const arrayDocIdSeleccionados = this.selected.map((item) => {
        return { docId: item.docId };
      });
    },

    async obtenerTodosDocId() {
      const arrayTodosDocId = this.desserts.map((item) => {
        return {
          docId: item.docId,
          z3b598ed3a: `${item.numero_orden1}-${item.numero_orden2}`,
        };
      });
      const ordenesSeccionadas = this.seccionarArrayOrdenes(arrayTodosDocId, 3);
      await this.actualizarEstadoGrupoOrdenes(ordenesSeccionadas);
    },
    /**
     * Función para seccionar un arreglo de órdenes en grupos de una longitud predeterminada
     */
    seccionarArrayOrdenes(arrayOrdenes, longitudSeccion) {
      let resultado = [];
      for (let i = 0; i < arrayOrdenes.length; i += longitudSeccion) {
        let seccion = arrayOrdenes.slice(i, i + longitudSeccion);
        resultado.push(seccion);
      }
      return resultado;
    },
    async actualizarEstadoGrupoOrdenes(ordenesSeccionadas) {
      let contadorResultado = 0;
      const fecha = new Date().getTime();
      this.$store.dispatch("setCargando", true);
      this.$emit("barra-progreso", true);
      this.$emit("valor-progreso", 0);
      if (ordenesSeccionadas.length <= 1) {
        await new Promise((resolve) => setTimeout(resolve, 200));
        this.$emit("valor-progreso", 45);
      }
      for (let j = 0; j < ordenesSeccionadas.length; j++) {
        try {
          await cambiarEstadoGrupoOrdenes(
            "completada",
            fecha,
            ordenesSeccionadas[j],
            this.$store.state.provider_email
          );
        } catch (err) {
          console.log(err);
        } finally {
          contadorResultado++;
          this.$emit(
            "valor-progreso",
            parseInt((contadorResultado / ordenesSeccionadas.length) * 100)
          );
          if (
            parseInt((contadorResultado / ordenesSeccionadas.length) * 100) ===
            100
          ) {
            await new Promise((resolve) => setTimeout(resolve, 500));
          }
        }
      }
      this.$store.dispatch("setCargando", false);
      this.$emit("barra-progreso", false);
      this.$emit("valor-progreso", 0);
      this.cerrarOverlay(false);
    },
    valorVerOverlaySubirArchivo() {
      this.overlaySubirArchivo = true;
    },
    cerrarOverlaySubirArchivo() {
      this.overlaySubirArchivo = false;
      this.$store.dispatch("setCargando", false);
    },
  },
};
</script>
<style lang="scss" src= './gestionAdministrativo.scss' scoped>
</style>
<style lang="scss" >
.graficaGestionAdministrativo {
  .container_gestion {
    .filtrosGestionAdministrativo {
      .col-12 {
        padding: 12px 0;
      }
    }
  }
  .v-data-table {
    td:last-child {
      padding: 0;
      min-width: 100px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Gestion/gestionAdministrativo/gestionAdministrativo.vue